import { useUser } from '@trustpad/launchpad';
import { useStakingProvider } from '@trustpad/launchpad/dist/staking/hooks/useStaking';

import React from 'react';

import { ZERO_BN } from '~config/constants';
import { StakingAdminForm } from '~features/staking/StakingAdminForm';

export function AdminPanel() {
  const { pool, stakingContract, totalStats } = useStakingProvider();
  const { account } = useUser();

  if (!pool?.admins?.includes(account)) {
    return null;
  }

  return (
    <div>
      <StakingAdminForm
        contract={stakingContract}
        rewardToken={pool.rewardToken}
        apr={totalStats.apr}
        onAprChange={() => {}}
        state={{
          halted: false,
          waitForRewardMaturity: false,
          treasury: '',
          rewardPerBlock: totalStats.rewardPerBlock,
          allowEarlyWithdrawal: false,
          lockPeriod: 0,
          rewardMaturityDuration: 0,
          totalStaked: ZERO_BN,
          alwaysLockOnRegister: false,
          stakingToken: Array.isArray(pool.stakeToken)
            ? pool.stakeToken[0].address
            : pool.stakeToken.address,
          rewardToken: pool.rewardToken.address,
          fees: {
            depositFee: ZERO_BN,
            withdrawFee: ZERO_BN,
            collectedDepositFees: ZERO_BN,
            collectedWithdrawFees: ZERO_BN,
            collectorAddress: '',
          },
        }}
      />
    </div>
  );
}
